export default __webpack_public_path__ + "static/patient-app-a4e1bb863f68dd9fffe2b02877b01948.jpg";